export default __webpack_public_path__ + "static/media/six.0e3f239c.jpg";